export default __webpack_public_path__ + "static/media/m_navBannerImg1.56b04460.png";